
export default {
  name: 'tab',
  components: {},
  props: {
    name: { required: true },
    selected: { default: false}
},

data() {
    
    return {
        isActive: false
    };
    
},

computed: {
    
    href() {
        return '#' + this.name.toLowerCase().replace(/ /g, '-');
    }
},

mounted() {
    
    this.isActive = this.selected;
    
}

}
